import React from "react";

import  Container  from "@mui/material/Container";
import  Grid  from "@mui/material/Grid";
import Box from "@mui/material/Box";

import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';


const Footer = () => {
    function scrollToHome() {
        document.getElementById("home").scrollIntoView({ behavior: "smooth" });
    }
    
    function scrollToAbout() {
        document.getElementById("about").scrollIntoView({ behavior: "smooth" });
    }
    
    function scrollToTokenomics() {
        document.getElementById("tokenomics").scrollIntoView({ behavior: "smooth" });
    }
    
    function scrollToRoadmap() {
        document.getElementById("roadmap").scrollIntoView({ behavior: "smooth" });
    }

    function scrollToAudit() {
        document.getElementById("audit").scrollIntoView({ behavior: "smooth" });
    }

    function scrollToWhitepaper() {
        document.getElementById("audit").scrollIntoView({ behavior: "smooth" });
    }


    return(
        <Box px={{  xs: 3, sm: 3, md: 10}} py={ { xs:5 ,sm:5, md: 10  } } style={ { backgroundColor: "#171324" } } id="social">
            <Container maxWidth="lg">
                <Grid container spacing={ 5 } mb={5} >
                    <Grid xs={12} sm={12} md={3} mb={5}  textAlign={{ xs: "center", md: 'start'}}  >
                        <Box mb={1}>
                            <span><img style={ { width: "3.75rem", float: "left"} } src="/logo.png" alt="logo"/></span><h2>REWARDS COIN</h2>
                        </Box>

                    </Grid>
                    <Grid xs={6} sm={6} md={3} mb={3} style={ { textAlign: "left", lineHeight: "1.2" } } paddingLeft={{ xs: "4rem", md: "7rem"}}>
                        <Box><p>Help</p></Box>
                        <Box><p style={{ cursor: "pointer" }} onClick={ scrollToAbout } >About 1RC</p></Box>
                        <Box><p style={{ cursor: "pointer" }} onClick={ scrollToTokenomics } >Tokenomics</p></Box>
                        <Box><p style={{ cursor: "pointer" }} onClick={ scrollToRoadmap } >Roadmap</p></Box>
                    </Grid>
                    <Grid xs={6} sm={6} md={3} mb={3} style={ { textAlign: "left", lineHeight: "1.2" } } paddingLeft={{ xs: "3rem",  md: "7rem"}}>
                        <Box><p style={{ cursor: "pointer" }} onClick={ scrollToAudit } >Audit</p></Box>
                        <Box><p style={{ cursor: "pointer" }} onClick={ scrollToWhitepaper } >Whitepaper</p></Box>
                        <Box><p style={{ cursor: "pointer" }} onClick={ scrollToHome } >Rewards</p></Box>
                    </Grid>
                    <Grid xs={12} sm={12} md={3} mb={3}  style={ { lineHeight: "1.2" } } paddingLeft={{ md: "5rem"}} display="flex" flexDirection="column" alignItems={{ sm:"center", xs:"center", md:"start" }}>
                        <h4>Supported Wallets</h4>
                        <img  src="/partners.png" alt="patners" style={ { width: "80%", maxWidth: "150px" }} />
                    </Grid>
                </Grid>
                <hr />
                <Box mt={3} >
                    <Container>
                    <Grid container >
                        <Grid item sm={12} xs={12} md={6} textAlign={{ xs: "center", md: 'start'}}>
                            <Box>
                                <a href="https://www.instagram.com/1rewardscoin" target="_blank" rel="noreferrer"><InstagramIcon style={ { color: "#fff", fontSize: "1.5rem", margin: "1rem", border:"1px solid white", borderRadius: "100%", padding: "0.5rem" } } /></a>
                                <a href="https://t.me/+GVls0L3Ta880NjM0" target="_blank" rel="noreferrer"><TelegramIcon style={ { color: "#fff", fontSize: "1.5rem", margin: "1rem", border:"1px solid white", borderRadius: "100%", padding: "0.5rem" } } /></a>
                                <a href="https://twitter.com/1RewardsCoin" target="_blank" rel="noreferrer"><TwitterIcon style={ { color: "#fff", fontSize: "1.5rem", margin: "1rem", border:"1px solid white", borderRadius: "100%", padding: "0.5rem" } } /></a>
                            </Box>
                        </Grid>
                        <Grid item sm={12} xs={12} md={6} textAlign={{ xs: "center", md: 'right'}}>
                            <Box>
                                <p>© 2022 Rewards Coin. All rights reserved.</p>
                            </Box>
                        </Grid>
                    </Grid>
                    </Container>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;